var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"button",staticClass:"ytpl-thumbnail",class:{
            'ytpl-active' : _vm.video.active
        },style:({
            'width': _vm.width+'px',
            'height': _vm.height+'px',
            'background-image': 'url(' + _vm.video.thumbnail + ')'
        }),attrs:{"type":"button","title":"Click to watch"},on:{"click":_vm.watchVideo}},[_c('div',{staticClass:"ytpl-thumbnail-overlay"},[_c('svg',{attrs:{"viewBox":"0 0 90 90","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M45 0C20.1 0 0 20.1 0 45s20.1 45 45 45 45-20.1 45-45S69.9 0 45 0zm24 46L30.8 70.5c-.8-.5-1-.5-1.8-1v-49c.8-.5 1-.5 1.8-1L69 44v2z","fill":_vm.btnColour,"fill-rule":"nonzero"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }